// Strip on every page of the test server (test.bestofthebest.cz), so nobody mistakes it
// for the real registration: changes here never reach registrace.bestofthebest.cz.
import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import { useMeta } from '../contexts/MetaContext';
import { useAuth } from '../hooks/useAuth';

export default function StagingBanner() {
  const meta = useMeta();
  const { user } = useAuth();
  if (!meta.isStaging) return null;
  return (
    <div role="note" className="border-b border-fuchsia-300 bg-fuchsia-600 px-4 py-1.5 text-sm text-white print:hidden">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-1">
        <FlaskConical className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <strong className="font-semibold tracking-wide">TESTOVACÍ VERZE</strong>
        <span>
          Zkušební kopie systému – změny se neprojeví v ostré registraci a e-maily se neodesílají.
          {meta.snapshotInfo ? ` ${meta.snapshotInfo}.` : ''}
        </span>
        {user?.role === 'admin' && !user?.impersonatedBy && (
          <Link to="/admin/outbox" className="ml-auto font-medium underline underline-offset-2 hover:text-fuchsia-100">
            Testovací pošta
          </Link>
        )}
      </div>
    </div>
  );
}
